import {api} from "@/app/services/api.service";

const state = {
    copyright:null,
    copyrightError:null,
    copyrightTask:null,
    copyrightTaskError:null,
    copyrightTaskCount:null,
    copyrightTaskCountError:null,
    copyrightTaskUpdateStatus:null,
    copyrightTaskUpdateStatusError:null,
    copyrightStatistics:null,
    copyrightStatisticsError:null,
    copyrights:null,
    copyrightsError:null,
    copyrightTaskMessages:null,
    copyrightTaskMessagesError:null,
    copyrightEscalation:null,
    copyrightEscalationError:null,
    copyrightEscalations:null,
    copyrightEscalationsError:null,
    copyrightRegistry:null,
    copyrightRegistryError:null,
};

const getters = {
    getCopyrightTask: (state) => state.copyrightTask,
    getCopyrightTaskError: (state) => state.copyrightTaskError,
    getCopyrightTaskCount: (state) => state.copyrightTaskCount,
    getCopyrightTaskCountError: (state) => state.copyrightTaskCountError,
    getCopyrightTaskUpdateStatus: (state) => state.copyrightTaskUpdateStatus,
    getCopyrightTaskUpdateStatusError: (state) => state.copyrightTaskUpdateStatusError,
    getCopyrightStatistics: (state) => state.copyrightStatistics,
    getCopyrightStatisticsError: (state) => state.copyrightStatisticsError,
    getCopyrights: (state) => state.copyrights,
    getCopyrightsError: (state) => state.copyrightsError,
    getCopyrightTaskMessages: (state) => state.copyrightTaskMessages,
    getCopyrightTaskMessagesError: (state) => state.copyrightTaskMessagesError,
    getCopyright: (state) => state.copyright,
    getCopyrightError: (state) => state.copyrightError,
    getCopyrightEscalation: (state) => state.copyrightEscalation,
    getCopyrightEscalationError: (state) => state.copyrightEscalationError,
    getCopyrightEscalations: (state) => state.copyrightEscalations,
    getCopyrightEscalationsError: (state) => state.copyrightEscalationsError,
    getCopyrightRegistry: (state) => state.copyrightRegistry,
    getCopyrightRegistryError: (state) => state.copyrightRegistryError,
};

const actions = {
    async fetchCopyrightTask({commit},applicationType){
        await api().get("copy-right/api/v1/applications/task/queue?applicationType="+applicationType).
        then(response => {
            commit('setCopyrightTask', response);
        }).catch(error => {
            commit("setCopyrightTaskError", error.response)
        });
    },
    async fetchCopyrightTaskCount({commit}){
        await api().get("copy-right/api/v1/applications/queue/count").
        then(response => {
            commit('setCopyrightTaskCount', response.data);
        }).catch(error => {
            commit("setCopyrightTaskCountError", error.response)
        });
    },
    async updateCopyrightTaskStatus({commit}, data){
        const payload = {
            applicationId: data.applicationId || data.copyrightId || "",
            taskId: data.taskId || data.queueId || "",
            status: data.status || "APPROVED",
            message: data.message || data.reason || "Application updated."
        };
        await api().post("copy-right/api/v1/applications/task/action", payload).
        then(response => {
            commit('setCopyrightTaskUpdateStatus', response.data);
        }).catch(error => {
            commit("setCopyrightTaskUpdateStatusError", error.response)
        });
    },
    async fetchCopyrightStatistics({commit}){
        await api().get("copy-right/api/v1/applications/stats").
        then(response => {
            commit('setCopyrightStatistics', response.data);
        }).catch(error => {
            commit("setCopyrightStatisticsError", error.response)
        });
    },
    async fetchAllCopyrightApplications({commit}, data) {
      let path="copy-right/api/v1/applications/list?status="+data.status+"&page="+data.page+"&pageSize="+data.limit;

      if(data.startRegistrationDate){
        path+="&dateOfEffectStart="+data.startRegistrationDate
      } if(data.endRegistrationDate){
        path+="&dateOfEffectEnd="+data.endRegistrationDate
      }
        await api()
            .get(path)
            .then(response => {
                commit('setCopyrights', response.data);
            }).catch(error => {
                commit("setCopyrightsError", error.response)
            });
    },
    async fetchCopyrightTaskMessages({commit}, data){
        let taskId = "";
        let path = "copy-right/api/v1/applications/task/messages/";
        if (typeof data === "object" && data !== null) {
            taskId = data.id || data.taskId || "";
            path += taskId;
            let params = [];
            if (data.page !== undefined) params.push("page=" + data.page);
            if (data.limit !== undefined) params.push("limit=" + data.limit);
            if (data.status !== undefined) params.push("status=" + data.status);
            if (params.length > 0) {
                path += "?" + params.join("&");
            }
        } else {
            taskId = data;
            path += taskId;
        }
        await api().get(path).
        then(response => {
            commit('setCopyrightTaskMessages', response.data);
        }).catch(error => {
            commit("setCopyrightTaskMessagesError", error.response)
        });
    },
    async fetchCopyrightByTrackingNumber({commit}, trackingNumber) {
        await api()
            .get("copy-right/api/v1/applications/tracking/" + trackingNumber)
            .then((response) => {
                commit("setCopyright", response.data);
            })
            .catch((error) => {
                commit("setCopyrightError", error.response);
            });
    },
    async fetchCopyrightByReservationNumber({commit}, reservationNumber) {
        await api()
            .get("copy-right/api/v1/applications/by-reservation-no/" + reservationNumber)
            .then((response) => {
                commit("setCopyright", response.data);
            })
            .catch((error) => {
                commit("setCopyrightError", error.response);
            });
    },
    async escalateCopyrightTask({commit, state}, data) {
        commit("setCopyrightEscalation", null);
        let appId = "";
        if (state.copyrightTask && state.copyrightTask.data && state.copyrightTask.data.applicationId) {
            appId = state.copyrightTask.data.applicationId;
        } else if (state.copyright && state.copyright.id) {
            appId = state.copyright.id;
        } else if (state.copyright && state.copyright.data && state.copyright.data.id) {
            appId = state.copyright.data.id;
        }
        const payload = {
            applicationId: data.applicationId || appId || "",
            taskId: data.taskId || data.queueId || "",
            userId: data.userId || data.registrarId || "",
            message: data.message || data.comment || ""
        };
        await api()
            .post("copy-right/api/v1/applications/task/escalate", payload)
            .then((response) => {
                commit("setCopyrightEscalation", response.data);
            })
            .catch((error) => {
                commit("setCopyrightEscalationError", error.response);
            });
    },
    async fetchCopyrightEscalations({commit}, data){
        await api().get("copy-right/api/v1/applications/task/escalations?page="+data.page+"&perPage="+data.limit).
        then(response => {
            commit('setCopyrightEscalations', response.data);
        }).catch(error => {
            commit("setCopyrightEscalationsError", error.response)
        });
    },
    async fetchCopyrightRegistry({commit}, data) {
        let path = "copy-right/api/v1/copyright/registry?page=" + data.page + "&pageSize=" + data.limit;
        if (data.search) {
            path += "&search=" + data.search;
        }
        if (data.certificateNumber) {
            path += "&certificateNumber=" + data.certificateNumber;
        }
        if (data.title) {
            path += "&title=" + data.title;
        }
        if (data.startDate) {
            path += "&startDate=" + data.startDate;
        }
        if (data.endDate) {
            path += "&endDate=" + data.endDate;
        }
        await api()
            .get(path)
            .then(response => {
                commit("setCopyrightRegistry", response.data);
            })
            .catch(error => {
                commit("setCopyrightRegistryError", error.response);
            });
    },
};

const mutations = {
    setCopyrightTask:(state, response) =>{
        state.copyrightTask = response.data
    },
    setCopyrightTaskError:(state, response) =>{
        state.copyrightTaskError = response.data
    },
    setCopyrightTaskCount:(state, response) =>{
        state.copyrightTaskCount = response && response.data ? response.data : response
    },
    setCopyrightTaskCountError:(state, response) =>{
        state.copyrightTaskCountError = response.data
    },
    setCopyrightTaskUpdateStatus:(state, response) =>{
        state.copyrightTaskUpdateStatus = response
    },
    setCopyrightTaskUpdateStatusError:(state, response) =>{
        state.copyrightTaskUpdateStatusError = response.data
    },
    setCopyrightStatistics:(state, response) =>{
        state.copyrightStatistics = response && response.data ? response.data : response
    },
    setCopyrightStatisticsError:(state, response) =>{
        state.copyrightStatisticsError = response.data
    },
    setCopyrights:(state, response) => {
        state.copyrights = response
    },
    setCopyrightsError:(state, error) => {
        state.copyrightsError = error
    },
    setCopyrightTaskMessages: (state, response) => {
        let content = [];
        if (response && response.data) {
            if (Array.isArray(response.data.content)) {
                content = response.data.content;
            } else if (Array.isArray(response.data)) {
                content = response.data;
            }
        } else if (response && Array.isArray(response.content)) {
            content = response.content;
        } else if (Array.isArray(response)) {
            content = response;
        }

        state.copyrightTaskMessages = content.map(msg => {
            if (msg.messageData) {
                return msg;
            }
            return {
                ...msg,
                messageData: {
                    sender: [msg.senderFirstName, msg.senderLastName].filter(Boolean).join(' ') || msg.senderId || 'System',
                    senderRole: msg.senderAccountType || '',
                    comment: msg.message || '',
                    createdAt: msg.createdAt
                }
            };
        });
    },
    setCopyrightTaskMessagesError: (state, response) =>{
        state.copyrightTaskMessagesErrors = response.data;
    },
    setCopyright: (state, response) =>{
        state.copyright = response.data;
    },
    setCopyrightError: (state, response) =>{
        state.copyrightError = response.data;
    },
    setCopyrightEscalation: (state, response) =>{
        state.copyrightEscalation = response;
    },
    setCopyrightEscalationError: (state, response) =>{
        state.copyrightEscalationError = response.data;
    },
    setCopyrightEscalations: (state, response) => {
        state.copyrightEscalations = response;
    },
    setCopyrightEscalationsError: (state, response) => {
        state.copyrightEscalationsError = response.data;
    },
    setCopyrightRegistry: (state, response) => {
        state.copyrightRegistry = response;
    },
    setCopyrightRegistryError: (state, response) => {
        state.copyrightRegistryError = response.data;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
